import { render, staticRenderFns } from "./SuccessModal.vue?vue&type=template&id=22cf4bcb&scoped=true&"
import script from "./SuccessModal.vue?vue&type=script&lang=js&"
export * from "./SuccessModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cf4bcb",
  null
  
)

export default component.exports